export default __webpack_public_path__ + "static/media/clock-icon.0a50aac4.png";